module.exports = __webpack_public_path__ + "static/media/files-pana.ffd83841.png";